import {FieldPathByValue, FieldValues, SetValueConfig} from 'react-hook-form';

import {Nullish} from 'shared/web';

import {DepositFieldName} from './DepositFieldName';
import {DepositMethodName} from './DepositMethodName';

/**
 * Binds the shared deposit section to the form of the module that renders it. React Hook Form
 * cannot resolve a literal field path against an unresolved generic form type, so each module
 * supplies these four adapters for its own concrete form type instead.
 */
export interface DepositFormBinding<TFieldValues extends FieldValues> {
  allowDepositFieldName: FieldPathByValue<TFieldValues, boolean | Nullish>;
  getFieldName: (field: DepositFieldName) => FieldPathByValue<TFieldValues, string | Nullish>;
  setFieldValue: (field: DepositFieldName, value: string | null, options?: SetValueConfig) => void;
  setMethodAllowed: (
    method: DepositMethodName,
    isAllowed: boolean,
    options?: SetValueConfig
  ) => void;
}
